import {
  TaxCalculatorResponse,
  TaxTableAndNoteResponse,
} from '@/modules/hs/types/tax.types'

import {
  HsTaxListResponse,
  HsTaxCommonResponse,
  HsTaxCBPGResponse,
  HsTaxCBPGCalculatorRequest,
  HsTaxCBPGCalculatorResponse,
} from '@/modules/hs/types/hs-tax.response'

import { api } from '@/modules/hs/api/api'

const baseURL =
  process.env.NEXT_PUBLIC_API_HOST_PORT || 'http://localhost:4444/api'

export async function getCBPGByHsCode(
  hsCode: string,
): Promise<HsTaxCBPGResponse[]> {
  const response = await fetch(`${baseURL}/hstax/tax-cbpg/${hsCode}`, {
    cache: 'force-cache',
    next: {
      revalidate: 86400,
      tags: ['tax-cbpg', `cbpg-${hsCode}`],
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch CBPG for code: ${hsCode}`)
  }

  return response.json()
}

export const calculateTaxCBPG = (
  data: HsTaxCBPGCalculatorRequest,
): Promise<HsTaxCBPGCalculatorResponse> =>
  api
    .post<HsTaxCBPGCalculatorResponse>(`/hstax/tax-cbpg/calculate`, data)
    .then((response) => response.data)

export async function getTaxListByHsCode(
  hsCode: string,
): Promise<HsTaxListResponse> {
  const response = await fetch(`${baseURL}/hstax/list/${hsCode}`, {
    cache: 'force-cache',
    next: {
      revalidate: 86400,
      tags: ['tax-list', `tax-${hsCode}`],
    },
  })


  if (!response.ok) {
    throw new Error(`Failed to fetch tax list for code: ${hsCode}`)
  }

  return response.json()
}

export async function getTaxTableAndNoteCached(): Promise<TaxTableAndNoteResponse> {
  const response = await fetch(`${baseURL}/hstax/tax-tables`, {
    cache: 'force-cache', // Explicitly enable caching
    next: {
      revalidate: 86400, // Revalidate after 24 hours
      tags: ['tax-tables'], // For on-demand revalidation
    },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch tax tables')
  }
  return response.json()
}

export const taxCalculator = (
  hsCode: string,
  countryName: string,
  importDate: string,
): Promise<TaxCalculatorResponse> =>
  api
    .post(`/hstax/tax-calculator`, {
      hsCode,
      countryName,
      importDate,
    })
    .then((response) => response.data)

export async function getVbplByHsCode(hsCode: string): Promise<any[]> {
  const response = await fetch(`${baseURL}/hscode/${hsCode}/vbpl`, {
    cache: 'force-cache',
    next: {
      revalidate: 86400,
      tags: ['vbpl', `vbpl-${hsCode}`],
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch VBPL for code: ${hsCode}`)
  }

  return response.json()
}

export async function getPolicyByHsCode(hsCode: string): Promise<any[]> {
  const response = await fetch(`${baseURL}/hscode/${hsCode}/policy`, {
    cache: 'force-cache',
    next: {
      revalidate: 86400,
      tags: ['policy', `policy-${hsCode}`],
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch Policy for code: ${hsCode}`)
  }

  return response.json()
}

export async function getRelatedByHsCode(hsCode: string): Promise<any[]> {
  const response = await fetch(`${baseURL}/hscode/${hsCode}/related`, {
    cache: 'force-cache',
    next: {
      revalidate: 86400,
      tags: ['related', `related-${hsCode}`],
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch Related codes for: ${hsCode}`)
  }

  return response.json()
}
